import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import { reducer as form } from 'redux-form'
import { reducer as notifs } from 'redux-notifications'
import { reducers as orders } from 'Pages/orders'
import { knowledgeReducers } from 'Pages/knowledge'
import { som } from 'Pages/som'
import { pp } from 'Pages/pp'
import { referenceBooks } from 'Pages/referenceBooks'
import content from 'Src/modules/content'
import intl from 'Src/modules/intl'
import modal from 'Src/modules/modal'
import grid from 'Src/modules/grid'
import pb from 'Src/modules/pb'
import page from 'Src/modules/page'
import filter from 'Src/modules/filter'
import generic from 'Src/modules/generic'
import { registratorCabinetReducers } from 'Pages/registratorCabinet'
import { createBrowserHistory } from 'history'
import { chatSlice } from 'Pages/chat'
import { iBro } from 'Pages/ibro'
import { advertisementReducers } from 'Pages/advertisement/store'
import { partnerSlice } from 'Pages/smsExpansion'
import { departmentSlice } from 'Pages/departments'
import { profileSlice } from 'Pages/profile/store/slices/profile.slice'
import { partnerRequestSlice } from 'src/pages/partnerRequests'
import { modules } from 'Modules'
import { adminSlice } from 'Pages/admin'
import { archiveBrokerSlice } from 'Pages/archiveBroker'
import { partnerProfile } from 'Pages/partnerProfile'
import { preloginSlice } from 'Pages/prelogin'
import { companySlice, partnerAddressesSlice } from 'Pages/company'
import { profileOrganizationSlice } from 'Pages/profileOrganization'
import { actsSlice } from 'Pages/acts'
import { coliseum } from 'Pages/coliseum'
import { registryBusinessAccessSlice } from 'Pages/registry_business_access_neo'
import { new_leads } from 'Pages/lead'
import { logs } from 'Pages/logs'
import { authSlice } from 'Pages/auth'
import { partner } from 'Pages/partner'
import { interfaceElementSlice } from 'Pages/interfaceElement'
import { dashboard } from 'Pages/dashboard'
import { survey } from 'Pages/survey'
import { usersReducers } from 'Pages/user'
import { bankEmployeesSlice } from 'Pages/bankEmployees'
import { ordersDesignReducers } from 'Pages/orders_design/store'
import { userDocumentsSlice } from 'Pages/profile'

const reducers = {
	form,
	content,
	intl,
	modal,
	grid,
	page,
	pb,
	notifs,
	filter,
	generic,
	orders,
	knowledge: knowledgeReducers,
	referenceBooks,
	adminSlice,
	[departmentSlice.name]: departmentSlice.reducer,
	[companySlice.name]: companySlice.reducer,
	[partnerAddressesSlice.name]: partnerAddressesSlice.reducer,
	[partnerRequestSlice.name]: partnerRequestSlice.reducer,
	[profileSlice.name]: profileSlice.reducer,
	[userDocumentsSlice.name]: userDocumentsSlice.reducer,
	[partnerSlice.name]: partnerSlice.reducer,
	logs,
	registratorCabinet: registratorCabinetReducers,
	iBro,
	[archiveBrokerSlice.name]: archiveBrokerSlice.reducer,
	[chatSlice.name]: chatSlice.reducer,
	registryBusinessAccess: registryBusinessAccessSlice,
	advertisement: advertisementReducers,
	[profileOrganizationSlice.name]: profileOrganizationSlice.reducer,
	modules,
	partnerProfile,
	[preloginSlice.name]: preloginSlice.reducer,
	coliseum,
	[authSlice.name]: authSlice.reducer,
	...actsSlice,
	new_leads,
	som,
	pp,
	partner,
	[interfaceElementSlice.name]: interfaceElementSlice.reducer,
	dashboard,
	survey,
	users: usersReducers,
	[bankEmployeesSlice.name]: bankEmployeesSlice.reducer,
	orders_design: ordersDesignReducers,
}

export const createRootReducer = (history: ReturnType<typeof createBrowserHistory>) => {
	const combinedReducer = combineReducers({
		...reducers,
		router: connectRouter(history),
	})

	return ((state, action) => {
		if (action.type === 'userSetting/destroyStore') {
			return undefined
		}
		return combinedReducer(state, action)
	}) as typeof combinedReducer
}
